import React, { useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CardContent,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  InputAdornment,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import AssignmentTurnedInOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import EventBusyOutlinedIcon from "@material-ui/icons/EventBusyOutlined";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";

const AccordionRespostas = (props) => {
  const { respostas, exibirComentarios = true, exibirAcoes = true, exibirSelect = true} = props;

  const [expandedAccordion, setExpandedAccordion] = useState(-1);

  const [acoesAnchorElement, setAcoesAnchorElement] = useState(null);

  const [acoesAccordionAnchorElement, setAcoesAccordionAnchorElement] =
    useState(null);
  const isMenuAcoesAccordionOpen = Boolean(acoesAccordionAnchorElement);

  const handleAccordionAcoesOpen = (event) => {
    event.stopPropagation();
    setAcoesAccordionAnchorElement(event.currentTarget);
  };

  const handleAccordionAcoesClose = () => {
    setAcoesAccordionAnchorElement(null);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : -1);
  };

  const acoesAccordionMenu = () => {
    return (
      // vertical: "top",
      <Menu
        anchorEl={acoesAnchorElement}
        anchorOrigin={{
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuAcoesAccordionOpen}
        onClose={handleAccordionAcoesClose}
      >
        <MenuItem disabled>Disponibilidade</MenuItem>
        <MenuItem>
          <InputAdornment position="start">
            <AssignmentTurnedInOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Disponibilizar
        </MenuItem>
        <Divider />
        <MenuItem disabled>Prazos</MenuItem>
        <MenuItem>
          <InputAdornment position="start">
            <DateRangeOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Estender prazo de preenchimento
        </MenuItem>
        <MenuItem>
          <InputAdornment position="start">
            <EventBusyOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Encerrar preenchimento
        </MenuItem>
        <Divider />
        <MenuItem disabled>Enviar</MenuItem>
        <MenuItem>
          <InputAdornment position="start">
            <EmailOutlinedIcon style={{ cursor: "pointer" }} />
          </InputAdornment>
          Enviar alerta de preenchimento
        </MenuItem>
      </Menu>
    );
  };

  return (
    <>
      {respostas.map((estado, index) => (
        <Accordion
          id={estado.ufAtuacao}
          key={"Accordion" + index}
          expanded={expandedAccordion === `${index}`}
          onChange={handleAccordionChange(`${index}`)}
          style={{ margin: "16px 0px", borderRadius: 6 }}
        >
          <AccordionSummary
            aria-label="Expand"
            key={"AccordionSummary1-" + index}
            style={{
              cursor: "pointer",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <Grid
              key={"grid0-" + index}
              style={{
                width: "-webkit-fill-available",
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <Grid
                key={"grid01-" + index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                {exibirSelect && (
                  <FormControlLabel
                  key={"grid010-" + index}
                  aria-label="Acknowledge"
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  control={<Checkbox disabled="true" />}
                  />
                )}
                <ExpandMoreIcon
                  key={"grid011-" + index}
                  style={{
                    transition: "transform 0.3s ease",
                    transform:
                      expandedAccordion == index ? "rotate(-90deg)" : "",
                  }}
                />
                <Typography
                  key={"grid012-" + index}
                  style={{ fontWeight: "bolder" }}
                >
                  {"Sebrae/" + estado.ufAtuacao}
                </Typography>
                {estado.quantidadeRespostasPreenchidas == 0 && (
                  <Chip
                    key={"grid013-" + index}
                    icon={
                      <ReportProblemOutlinedIcon key={"grid0130-" + index} />
                    }
                    label="Nenhuma resposta enviada!"
                    style={{ backgroundColor: "yellow" }}
                  />
                )}
              </Grid>
              <Grid
                key={"grid02-" + index}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <Typography component="div" key={"grid021-" + index}>
                  {estado.quantidadeRespostasPreenchidas}
                  {estado.quantidadeRespostasPreenchidas == 1
                    ? " resposta"
                    : " respostas"}
                </Typography>
                {exibirAcoes && (
                <Grid key={"grid022-" + index}>
                <Button
                  key={"grid0220-" + index}
                  id="acoes"
                  name="acoes"
                  onClick={(event) => handleAccordionAcoesOpen(event)}
                  variant="outlined"
                  disabled="disabled"
                >
                  Ações
                  <ExpandMoreIcon key={"grid0221-" + index} />
                </Button>
              </Grid>
                )}
              </Grid>
            </Grid>
          </AccordionSummary>
          <AccordionDetails
            key={"AccordionDetails1-" + index}
            style={{
              display: "flex",
              flexDirection: "column",
              flexWrap: "nowrap",
              alignItems: "flex-start",
            }}
          >
            {expandedAccordion == index &&
              estado.respostas?.map((resposta, index) => (
                <Grid
                  key={"grid1-" + index}
                  variant="outlined"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    border: "1px solid lightgray",
                    gap: "20px",
                    borderRadius: 6,
                    marginBottom: "10px",
                  }}
                >
                  <Grid
                    key={"grid2c-" + index}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "10px 10px 0px",
                    }}
                  >

                    <Grid
                      key={"grid2a-" + index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        padding: "10px 10px 0px",
                        gap:"5px"
                      }}
                    >
                      <Typography
                        key={"grid21-" + index}
                        style={{ fontWeight: "bolder" }}
                        component="div"
                      >
                        Pergunta {index+1}: 
                      </Typography>
                      {resposta.nomeCampoFormulario}
                    </Grid>
                    
                    {exibirComentarios && (
                      <Grid
                        key={"grid22-" + index}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        {/* onClick={() => setOpenVincularFormulario(true)} */}
                        <Button
                          key={"grid221-" + index}
                          id="estados"
                          name="estados"
                          variant="outlined"
                          disabled="disabled"
                        >
                          <ForumOutlinedIcon key={"grid2211-" + index} />
                          Adicionar comentário
                        </Button>
                        {/* onClick={() => setOpenVincularFormulario(true)} */}
                        <Button
                          key={"grid2212-" + index}
                          id="estados"
                          name="estados"
                          variant="outlined"
                          disabled="disabled"
                        >
                          <SearchOutlinedIcon key={"grid2213-" + index} />
                          Comentários (2)
                        </Button>
                      </Grid>
                    )}
                  </Grid>

                  <Grid
                    key={"grid3-" + index}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      padding: "0px 20px 0px",
                      gap:"5px"
                    }}
                  > 
                    <Typography
                          key={"grid21-" + index}
                          style={{ fontWeight: "bolder" }}
                          component="div"
                        >
                          Resposta: 
                    </Typography>
                    <CardContent dangerouslySetInnerHTML={{
                      __html: resposta.resposta ?? "<span style='color:gray; font-style:italic;'>Sem resposta até o momento</span>"
                    }}/>
                  </Grid>
                </Grid>
              ))}
          </AccordionDetails>
        </Accordion>
      ))}

      {acoesAccordionMenu()}
    </>
  );
};

export default AccordionRespostas;
